import React from 'react';
import { getAnchorTagTrainRoutes } from '../utils/recommendTripPathListUtils';
import PropTypes from 'prop-types';

export const TrainRouteRecommend = ({
  trainRouteProps: { source, destination, link, routePageUrl },
  additionalProps: { vernacularSourceCityName, vernacularDestinationCityName, recommendRouteObject, idx }
}) => (
  <li key={`${source}_${destination}_${idx}`} className="appendBottom10">
    <a href={link || routePageUrl} className="font14 darkGreyText railSeoWrap__rwStnListLink">
      {getAnchorTagTrainRoutes({
        stringToFormat: recommendRouteObject.format,
        replaceSourceWith: source || vernacularSourceCityName,
        replaceDestWith: destination || vernacularDestinationCityName
      })}
    </a>
  </li>
);

TrainRouteRecommend.propTypes = {
  trainRouteProps: PropTypes.object,
  additionalProps: PropTypes.object
};
export default TrainRouteRecommend;
